export enum EContactsListDisplayType {
	normal = "normal",
	v1 = "v1"
}